import { UsernameValidationError } from '../errors';
export class UsernameValidation {
    constructor(field) {
        this.field = field;
    }
    validate(input) {
        return !input[this.field] || String(input[this.field]).match(/^[a-zA-Z0-9_]{4,20}$/)
            ? null
            : new UsernameValidationError();
    }
}
